import styled from 'styled-components';

export const InfluenceStepContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-top: 10px;
`;
